/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CreateOneloginOauthKeyInput = {|
  email?: ?string,
  issuer?: ?string,
  clientMutationId?: ?string,
|};
export type createOneloginOauthKeyMutationVariables = {|
  input: CreateOneloginOauthKeyInput
|};
export type createOneloginOauthKeyMutationResponse = {|
  +createOneloginOauthKey: ?{|
    +key: ?string,
    +oneloginClientId: ?string,
    +oneloginUrl: ?string,
  |}
|};
export type createOneloginOauthKeyMutation = {|
  variables: createOneloginOauthKeyMutationVariables,
  response: createOneloginOauthKeyMutationResponse,
|};
*/


/*
mutation createOneloginOauthKeyMutation(
  $input: CreateOneloginOauthKeyInput!
) {
  createOneloginOauthKey(input: $input) {
    key
    oneloginClientId
    oneloginUrl
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateOneloginOauthKeyInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateOneloginOauthKeyPayload",
    "kind": "LinkedField",
    "name": "createOneloginOauthKey",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "key",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "oneloginClientId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "oneloginUrl",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createOneloginOauthKeyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createOneloginOauthKeyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createOneloginOauthKeyMutation",
    "operationKind": "mutation",
    "text": "mutation createOneloginOauthKeyMutation(\n  $input: CreateOneloginOauthKeyInput!\n) {\n  createOneloginOauthKey(input: $input) {\n    key\n    oneloginClientId\n    oneloginUrl\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '0b656fd5682af6552258e76eb64e1f3f';

module.exports = node;
